import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Home.vue";
import Main from "../views/Main.vue";
import Login from "../views/Login.vue";
import Profile from "../views/Profile.vue";
import Logout from "../views/Logout.vue";
import Directory from "../views/Directory.vue";
import Products from "../views/Products.vue";
import Shops from "../views/Shops.vue";
import Skus from "../views/modals/_sku.vue";
import Sales from "../views/Sales.vue";
import Stocks from "../views/Stocks.vue";
import AddShop from "../views/modals/_addShop.vue";
import AddLocation from "../views/modals/_addLocation.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { middlewareAuth: false },
  },
  {
    path: "/",
    name: "Home",
    component: Main,
    meta: { middlewareAuth: true },
    children: [
      {
        path: "/dashboard",
        name: "Happenstance",
        component: Dashboard,
      },
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
      },
      {
        path: "/directory",
        name: "Directory",
        component: Directory,
      },
      {
        path: "/products",
        name: "Products",
        component: Products,
      },
      {
        name: "Skus",
        path: "products/:id/sku",
        props: true,
        components: {
          default: Products,
          dialog: Skus,
        },
      },
      {
        path: "/shops",
        name: "Shops",
        component: Shops,
      },
      {
        path: "/addShop",
        name: "Add new shop",
        component: AddShop,
      },
      {
        path: "/addLocation",
        name: "Add new loacation",
        component: AddLocation,
      },
      {
        path: "/sales",
        name: "Sales",
        component: Sales,
      },
      {
        path: "/:id/sales",
        name: "Sales by Shop",
        component: Sales,
      },
      {
        path: "/stocks",
        name: "Stocks",
        component: Stocks,
      },
    ],
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
